// extracted by mini-css-extract-plugin
module.exports = {"category-nav":"styles_category-nav__n4tTw"};